import "./index.css";
import Player, {Events} from "xgplayer";
import FlvPlayer from "xgplayer-flv";
import HlsPlugin from "xgplayer-hls";
// import poster from "./poster.png";
import {customPageTurning} from "../plugin"


class PmStreaming {
    constructor(params = {}) {
        const {
            playSuccess,
            playError,
            playStabilize,
            playStart,
            playInfo,
            playPrev,
            playNext,
            playDestroy,
            playPause,
            ...options
        } = params;
        this.handle = {
            playInfo, // 播放信息，网速
            playStart,// 开始准备工作，已经在获取拉流信息
            playSuccess, // 播放成功
            playError, // 播放失败
            playStabilize, // 播放不稳定
            playPrev, // 上一页
            playNext, // 下一页
            playDestroy, // 销毁的回调
            playPause, // 播放暂停
        }
        this.options = Object.assign({
            url: '',
            // poster,
            isLive: true, // 是否直播
            preloadTime: 45, // 预加载时长(秒)
            minCachedTime: 10, // 当前播放时间距离已缓存资源片段结束点剩多长时间时开始请求新片段(秒)
            cors: true,
            autoplay: true,
            autoplayMuted: true,
            height: 300,
            width: 500,
            playbackRate: [], // 关闭播放速度切换
            ignores: ['replay'],
            lang: 'zh-cn',
            flv: {
                disconnectTime: 0,
                retryDelay: 2000,
                loadTimeout: 5000,
                bufferBehind: 1000,
                retryCount: 3,
            },
            plugins: [FlvPlayer],
            initShow: false,
            pageTurning: false,// 自定开发插件 上一页 下一页
            // screenShot: {
            //     saveImg: true,
            //     quality: 0.92,
            //     type: 'image/png',
            //     format: '.png'
            // },
        }, options)
        this.RECONNECTS = 0;
        this.RECONNECTSMAX = 10;
        this.init()
    }

    init() {
        if (FlvPlayer.isSupported()) {
            this.player = new Player(this.options)
            this.player.once('ready', () => {
                setTimeout(() => {
                    this.handleRegister()
                }, 1000);
            })
        }
    }

    handleRegister() {
        this.options.pageTurning && customPageTurning(this.player, this.options, this.handle)
        // 准备阶段
        this.player.on(Events.LOAD_START, (res) => {
            this.handle.playStart && this.handle.playStart(res)
        })

        // 播放成功
        this.player.on(Events.PLAY, (res) => {
            this.RECONNECTS = 0;
            this.handle.playSuccess && this.handle.playSuccess(res)
        })

        // 播放暂停
        this.player.on(Events.PAUSE, (res) => {
            this.handle.playPause && this.handle.playPause(res)
        })

        // 播放错误
        this.player.on(Events.ERROR, (err) => {
            this.disconnectionReconnects()
            this.handle.playError && this.handle.playError(err)
        })

        // 断开，重新播放，不稳定
        this.player.on(Events.PLAYING, (res) => {
            this.handle.playStabilize && this.handle.playStabilize(res)
        })

        this.player.on('core_event', ({eventName, ...rest}) => { // eventName: flv 事件名; rest: flv 事件回调函数参数
            this.handle.playInfo && this.handle.playInfo(this.getPlayInfo())
        })

        this.player.once('destroy', () => {
            console.log("播放器销毁")
            this.clearStorage()
            this.handle.playDestroy && this.handle.playDestroy()
        })

        // 自动播放失败
        this.player.on(Events.AUTOPLAY_PREVENTED, () => {
            try {
                this.player.play()
                setTimeout(() => {
                    if (!this.player.hasStart && this.player.currentTime === 0) {
                        console.log('自动播放失败')
                    }
                }, 500)
            } catch (e) {
                console.log(e);
            }
        })

        // 关于自动播放问题，https://h5player.bytedance.com/guide/extends/aautoplay.html#%E7%A7%BB%E5%8A%A8%E7%AB%AF%E8%87%AA%E5%8A%A8%E6%92%AD%E6%94%BE
        this.player.on(Events.AUTOPLAY_STARTED, () => {
            console.log('autoplay success!!')
        })
    }

    getFlvPlayer() {
        return FlvPlayer;
    }

    getPlayInfo() {
        const {speed} = this.player.plugins.flv.core.speedInfo();
        const {downloadSpeed, avgSpeed} = this.player.plugins.flv.core.getStats();
        const kb = 8 * 1024;
        return {
            speed: speed / kb,
            downloadSpeed: downloadSpeed / kb,
            avgSpeed: avgSpeed / kb
        }
    }

    disconnectionReconnects() {
        this.RECONNECTS++
        if (this.RECONNECTS <= this.RECONNECTSMAX) {
            console.log('断线重连中' + this.RECONNECTS + '次')
            this.init()
        }
    }

    clearStorage() {
        if (this.RECONNECTS >= this.RECONNECTSMAX) {
            console.log(`超出最大链接次数${this.RECONNECTSMAX},刷新页面重新请求`)
        }
        this.player = null;
    }

    destroy() {
        console.log("播放器销毁启动")
        if (this.player){
            this.player.pause()
            this.player.destroy()// 销毁播放器
        }
    }
}


export default PmStreaming;
